import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, HttpClient, withInterceptors, HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { LAYOUT_SERVICE_TOKEN, UiKitPrimeNgConfig } from '@beta-foundations/ui-kit';
import { LayoutService } from '@beta-foundations/ui-kit/services';
import { providePrimeNG } from 'primeng/config';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ENVIRONMENT } from '../const';
import { environment } from '../environments/environment';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { authInterceptor } from './auth/auth.interceptor';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function appInitializerFactory(translate: TranslateService) {
  return () => {
    translate.addLangs(['en', 'it']);
    translate.setDefaultLang('it');
    return translate.use('it').toPromise().catch(error => {
      console.error('Errore nel caricamento iniziale delle traduzioni:', error);
      return Promise.resolve();
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    { provide: LAYOUT_SERVICE_TOKEN, useClass: LayoutService },
    provideAnimationsAsync(),
    providePrimeNG(UiKitPrimeNgConfig),

    provideHttpClient(withInterceptors([authInterceptor])),

    { provide: ENVIRONMENT, useValue: environment },

    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),

    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true
    },

    MessageService,
    DialogService,
  ]
};
